import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LoadData } from "../mobile-screens/models/LoadData";
import { AlertTruckerLocationListItem } from "../models/AlertTruckerLocationListItem";
import { CommodityListItem } from "../models/CommodityListItem";
import { CreateSchedulesResponse } from "../models/CreateSchedulesResponse";
import { DeleteParameters } from "../models/DeleteParameters";
import { Dispatch } from "../models/Dispatch";
import { DispatchItem } from "../models/DispatchItem";
import { FilteredTruckersInfo } from "../models/FilteredTruckersInfo";
import { ListItem } from "../models/ListItem";
import { Load } from "../models/Load";
import { LoadBreakout } from "../models/LoadBreakout";
import { LoadBreakoutParameters } from "../models/LoadBreakoutParameters";
import { MobileFilterParamsDropdown } from "../models/MobileFilterParamsDropdown";
import { MoveScheduleDispatchLoads } from "../models/MoveScheduleDispatchLoads";
import { Schedule } from "../models/Schedule";
import { ScheduleItem } from "../models/ScheduleItem";
import { ScheduleLoads } from "../models/ScheduleLoads";
import { ScheduleParameters } from "../models/ScheduleParameters";
import { ScheduleRequest } from "../models/ScheduleRequest";
import { SchedulesInfo } from "../models/SchedulesInfo";
import { StagingItem } from "../models/StagingItem";
import { TruckerItem } from "../models/TruckerItem";
import { DispatchFilterLists } from "../models/DispatchFiltersLists";


@Injectable({
    providedIn: 'root'
})
export class ScheduleDataService {

    private currentPageData: any;


    constructor(private http: HttpClient) {

    }
    scheduleParms: ScheduleParameters;

    getStagingItems(parms: ScheduleParameters): Observable<StagingItem[]> {
        return this.http.post<StagingItem[]>('api/schedule/getstaging', parms);
    }

    getDefaultSchedules(parms: ScheduleParameters): Observable<StagingItem[]> {
        return this.http.post<StagingItem[]>('api/schedule/getdefaultschedules', parms);
    }

    createStagingSchedules(parms: ScheduleParameters): Observable<CreateSchedulesResponse> {
        return this.http.post<CreateSchedulesResponse>('api/schedule/createstagingschedules', parms);
    }

    createDefaultSchedules(parms: ScheduleParameters): Observable<CreateSchedulesResponse> {
        return this.http.post<CreateSchedulesResponse>('api/schedule/createdefaultschedules', parms);
    }

    getSchedules(parms: ScheduleParameters): Observable<SchedulesInfo> {
        return this.http.post<SchedulesInfo>('api/schedule/getschedules', parms);
    }

    getSchedulesWithFilters(parms: ScheduleParameters): Observable<ScheduleItem[]> {
        return this.http.post<ScheduleItem[]>('api/schedule/GetSchedulesWithFilters', parms);
    }

    getCommoditiesForTruckers(parms: ScheduleParameters): Observable<CommodityListItem[]> {
        return this.http.post<CommodityListItem[]>('api/schedule/getcommoditiesfortruckers', parms);
    }

    getOriginAndDestinationListForTruckers(parms: ScheduleParameters): Observable<AlertTruckerLocationListItem[]> {
        return this.http.post<AlertTruckerLocationListItem[]>('api/schedule/getoriginanddestinationlistfortruckers', parms);
    }

    getSchedule(scheduleId: number): Observable<Schedule> {
        return this.http.get<Schedule>('api/schedule/getschedule/' + scheduleId);
    }

    getScheduleItem(request: ScheduleRequest): Observable<ScheduleItem> {
        return this.http.post<ScheduleItem>('api/schedule/getscheduleitem', request);
    }

    getDispatchesWithFilters(parms: ScheduleParameters): Observable<DispatchItem[]> {
        return this.http.post<DispatchItem[]>('api/schedule/GetDispatchesWithFilters', parms);
    }

    getScheduleDispatches(scheduleId: number): Observable<DispatchItem[]> {
        return this.http.get<DispatchItem[]>('api/schedule/GetScheduleDispatches/' + scheduleId);
    }

    saveSchedule(schedule: Schedule): Observable<number> {
        return this.http.post<number>('api/schedule/saveschedule', schedule);
    }

    deleteDefaultSchedule(defaultScheduleId: number): Observable<boolean> {
        return this.http.delete<boolean>('api/schedule/deletedefaultschedule/' + defaultScheduleId);
    }

    deleteSchedule(scheduleId: number): Observable<boolean> {
        return this.http.delete<boolean>('api/schedule/deleteschedule/' + scheduleId);
    }

    getDispatch(dispatchId: number): Observable<Dispatch> {
        return this.http.get<Dispatch>('api/schedule/getdispatch/' + dispatchId);
    }

    getDispatchItem(dispatchId: number): Observable<DispatchItem> {
        return this.http.get<DispatchItem>('api/schedule/GetDispatchItem/' + dispatchId);
    }

    getDispatchLoadItems(dispatchId: number): Observable<LoadData[]> {
        return this.http.get<LoadData[]>('api/mobile/getdispatchloads/' + dispatchId);
    }

    saveDispatch(dispatch: Dispatch): Observable<number> {
        return this.http.post<number>('api/schedule/savedispatch', dispatch);
    }

    deleteDispatch(dispatchId: number): Observable<number[]> {
        return this.http.delete<number[]>('api/schedule/deletedispatch/' + dispatchId);
    }

    saveScheduleLoads(scheduleLoads: ScheduleLoads): Observable<number> {
        return this.http.post<number>('api/schedule/savescheduleloads', scheduleLoads);
    }

    movescheduledispatchloads(moveScheduleDispatchLoads: MoveScheduleDispatchLoads): Observable<boolean> {
        return this.http.post<boolean>('api/schedule/movescheduledispatchloads', moveScheduleDispatchLoads);
    }

    saveLoad(load: Load): Observable<number> {
        return this.http.post<number>('api/schedule/saveload', load);
    }

    saveLoadForMobile(load: LoadData): Observable<number> {
        return this.http.post<number>('api/mobile/saveloadmobile', load);
    }

    deleteLoad(loadId: number): Observable<number> {
        return this.http.delete<number>('api/schedule/deleteload/' + loadId);
    }

    generateLoadBreakout(parms: LoadBreakoutParameters): Observable<LoadBreakout> {
        return this.http.post<LoadBreakout>('api/schedule/generateloadbreakout', parms);
    }

    generateLoadBreakouts(parms: LoadBreakoutParameters): Observable<LoadBreakout[]> {
        return this.http.post<LoadBreakout[]>('api/schedule/generateloadbreakouts', parms);
    }

    getTruckersForSchedules(parms: ScheduleParameters): Observable<TruckerItem[]> {
        return this.http.post<TruckerItem[]>('api/schedule/gettruckersforschedules/', parms)
    }

    getTruckerDispatchesById(customerId: number, parms: ScheduleParameters): Observable<DispatchItem[]> {
        return this.http.post<DispatchItem[]>('api/schedule/gettruckerdispatchesbyid/' + customerId, parms)
    }

    getDispatchFilterLists(parms: ScheduleParameters): Observable<DispatchFilterLists> {
        return this.http.post<DispatchFilterLists>('api/schedule/getdispatchfilterlists/', parms)
    }

    getTruckerListForSchedules(parms: ScheduleParameters): Observable<ListItem[]> {
        return this.http.post<ListItem[]>('api/schedule/gettruckerlistforschedules/', parms)
    }

    getLocationListForSchedules(parms: ScheduleParameters): Observable<ListItem[]> {
        return this.http.post<ListItem[]>('api/schedule/getlocationlistforschedules/', parms)
    }

    getLocationCityListForSchedules(parms: ScheduleParameters): Observable<ListItem[]> {
        return this.http.post<ListItem[]>('api/schedule/getlocationcitylistforschedules/', parms)
    }

    getScheduleDaysList(parms: ScheduleParameters): Observable<ListItem[]> {
        return this.http.post<ListItem[]>('api/schedule/getscheduledayslist/', parms)
    }

    setCurrentPageData(data: any) {
        this.currentPageData = data;
    }

    getCurrentPageData() {
        return this.currentPageData;
    }

    getFilteredTruckers(searchParms: ScheduleParameters): Observable<FilteredTruckersInfo[]> {

        return this.http.post<FilteredTruckersInfo[]>('api/listitem/getfilteredtruckers/', searchParms);
    }

    getMobileFilterLists(searchParms: ScheduleParameters): Observable<MobileFilterParamsDropdown> {
        return this.http.post<MobileFilterParamsDropdown>('api/mobile/GetMobileFilterLists', searchParms);
    }

    updateLoadBankApply(dispatchId: number, loadBankIds: number[], isUnLoadApply: boolean): Observable<boolean> {
        const params = new HttpParams()
            .set('dispatchId', dispatchId.toString())
            .set('isUnLoadApply', isUnLoadApply.toString());
        return this.http.post<boolean>('api/mobile/updateloadbankapply', loadBankIds, { params });
    }

    getRogerInProcessLoadCount(params: DeleteParameters): Observable<number> {
        return this.http.post<number>('api/roger/getRogerInProcessLoadCount/', params);
    }

    getDefaultAccountIdForNewDispatch(scheduleId: number): Observable<number> {
        return this.http.get<number>('api/schedule/getdefaultaccountid/' + scheduleId);
    }
}